export const modelSwitcher = ()=>{

  const container = document.querySelector('.product-meta__related-products')

  if(container){
    container.addEventListener('click',()=>{
      container.classList.toggle('open');
    })
    const links = container.querySelectorAll('.related a')

    const listItems = container.querySelectorAll('.related li')

    let biggestItem = 0;

    if(listItems){
      listItems.forEach((item, i) => {
        const bounds = item.getBoundingClientRect()
        if(bounds && bounds.width && bounds.width > biggestItem){
          biggestItem = bounds.width
        }
      });
    }
    if(biggestItem > 0){
      container.style.width = `${biggestItem}px`;
    }

    container.addEventListener('focusout',(event)=>{
        if (container.contains(event.relatedTarget)) {
          // don't react to this
          return;
        }
        container.classList.remove('open');
    })
  }

}

export const customOption = ()=>{
  let times = 0;
  const interval = setInterval(()=>{
    const engravingOption = document.querySelector('.product-engraving');
    times += 1

    if(engravingOption){
      const engravingLink = document.querySelector('.product-option-engraving-link')
      engravingLink && engravingLink.classList.add('visible')
    }
    if(times === 30 || engravingOption){
      clearInterval(interval);
    }
  },400)
}
